

import { Component, Vue, Watch, Prop, InjectReactive, Inject } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import vSelect from "vue-select"
import CaseFileDisplay from "./CaseFileDisplay.vue"
import Confirmation from "../../Confirmation.vue"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { CaseDetails, CaseField, CaseAudit } from "@/types"
import CaseFile from "@/types/caseFile"

import api from "@/services/api"
import FileService from "@/services/file-service"

const caseStore = namespace("cases")

@Component({
	components: {
		"case-file": CaseFileDisplay,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"confirm": Confirmation
	}
})
export default class CaseFileUpload extends Vue {
	@Inject("fileService") fileService!: FileService;

	$refs!: {
		confirmModal: Confirmation
	}

	@Prop({ type: Boolean, default: false })
	public creatingNewCase!: boolean;

	@Prop({ type: String || null, default: null })
	public fieldId!: string | null;

	@Prop({ type: String || null, default: null })
	public fieldName!: string | null;

	@Prop({ type: Boolean, default: false })
	public showUploadingFiles!: boolean;

	@Prop({ type: Boolean, default: false })
	public displayAsList!: boolean;

	@Prop({ type: Boolean, default: false })
	viewOnly!: boolean;

	@Prop()
	public caseFiles!: CaseFile[];

	private uploadFieldName: any = "files";
	private dragging: boolean = false;
	private uploadSupportPageUrl: string | undefined = process.env.VUE_APP_UPLOADS_SUPPORT_PAGE_URI;

	public get uploadingFiles () {
		if (!this.fileService) {
			return []
		}
		return this.fileService.uploadFiles.filter((file: any) => file.fieldId === this.fieldId)
	}

	private async onChange (event: any): Promise<void> {
		this.dragging = false
		if (this.creatingNewCase) {
			return
		}

		if (this.viewOnly) return

		let files = (event.target.files || event.dataTransfer.files) as any[]

		const uploadFiles: any[] = []
		files.forEach(file => {
			const newFile = {
				fieldId: this.fieldId,
				name: file.name,
				fileData: file,
				uploading: false,
				uploadPercentage: 0,
				failed: false,
				success: false,
				error: null,
				uploadRun: false
			}

			uploadFiles.push(newFile)
		})

		// this.uploadFiles({ fieldId: this.fieldId, uploadFiles: uploadFiles })
		this.fileService.addFiles(uploadFiles)
	}

	deleteFile (file: CaseFile) {
		this.$refs.confirmModal.open(file.filename, () => {
			this.fileService.deleteFile(file.id)
		})
	}
}
